//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavBriefcaseFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17.47 6L14.95 3H9.05L6.53 6H2V14H11V12H13V14H22V6H17.47ZM9.14 6L9.98 5H14.01L14.85 6H9.14Z" fill="currentColor" /><path d="M13 17H11V16H2V21H22V16H13V17Z" fill="currentColor" /></svg>;
}
export default IconNavBriefcaseFill;